// extracted by mini-css-extract-plugin
export default {"header":"AfwMa1OTQ4lWc1UAqGhU"};